module.exports = __webpack_public_path__ + "img/94.622dae5e.png";